// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* components/admpelada.css */

/* Container & Header */
.admin-screen {
  display: grid;
  gap: 16px;
  padding: 16px;
  background: #0b1220;        /* dark base */
  min-height: 100vh;
  color: #e5e7eb;
}
.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.2px;
}
.header-actions { display: flex; gap: 8px; }

/* Cards */
.card {
  background: #0e172a;
  border: 1px solid #1f2a44;
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.35);
}
.card__head {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 10px;
}
.card__title {
  font-size: 16px;
  font-weight: 700;
}

/* Buttons */
.btn {
  background: #1f2a44;
  border: 1px solid #283759;
  color: #e5e7eb;
  padding: 10px 12px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
}
.btn:hover { filter: brightness(1.08); }
.btn:disabled { opacity: 0.6; cursor: not-allowed; }

.btn--primary {
  background: #10b981;
  border-color: #0f9d75;
  color: #06251f;
}
.btn--ghost {
  background: transparent;
  border-color: #283759;
}

/* Form / Read grids (responsivas) */
.form-grid, .read-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}
.field { display: flex; flex-direction: column; gap: 6px; }
.field--row { flex-direction: row; align-items: center; gap: 8px; }
.label-inline { display: flex; align-items: center; gap: 8px; }

.input {
  background: #0b1220;
  color: #e5e7eb;
  border: 1px solid #1f2a44;
  padding: 10px 12px;
  border-radius: 10px;
  outline: none;
  width: 100%;
  box-sizing: border-box;
}
.input:focus { border-color: #375399; }
.input--xs { max-width: 96px; }

.form-actions {
  grid-column: 1 / -1;
  display: flex; justify-content: flex-end; gap: 8px; margin-top: 6px;
}
.divider {
  grid-column: 1 / -1;
  height: 1px;
  background: #1f2a44;
  margin: 2px 0 8px 0;
}

/* Read-only items */
.read-item { display: grid; gap: 4px; }
.read-label { font-size: 12px; color: #9ca3af; }
.read-value { font-weight: 600; }

/* Badges traduzidas */
.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid #283759;
  background: #0b1220;
}
.badge--open     { color: #10b981; border-color: #0f9d75; }
.badge--closed   { color: #f59e0b; border-color: #9a6b09; }
.badge--canceled { color: #f97373; border-color: #7f1d1d; }
.badge--finished { color: #93c5fd; border-color: #1d4ed8; }

/* Pills (chips) — responsivas, sem sobreposição */
.pill-row {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); /* quebre conforme a largura */
  margin-bottom: 10px;
}
.pill {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid #283759;
  background: #0b1220;
  font-weight: 700;
  min-height: 44px;         /* área toque-friendly */
  box-sizing: border-box;
}
.pill__label { font-size: 13px; color: #9ca3af; }
.pill__value { font-size: 14px; }
.pill--green  { border-color: #0f9d75; }
.pill--amber  { border-color: #9a6b09; }
.pill--red    { border-color: #7f1d1d; }
.pill--over   { box-shadow: inset 0 0 0 999px rgba(127,29,29,0.08); }

/* Progress — responsivo */
.progress-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  margin-bottom: 4px;
}
.progress-title { font-size: 12px; color: #9ca3af; margin: 2px 0 6px; }
.progress {
  width: 100%;
  height: 10px;
  background: #0b1220;
  border: 1px solid #1f2a44;
  border-radius: 999px;
  overflow: hidden;
}
.progress__bar {
  height: 100%;
  background: linear-gradient(90deg, #375399, #10b981 66%);
}

/* Helpers */
.muted { color: #9ca3af; font-size: 12px; }
.error-message {
  background:#2a0f11; color:#fecaca; border:1px solid #7f1d1d;
  padding:10px 12px; border-radius:10px;
}
.success-message {
  background:#0f2a17; color:#bbf7d0; border:1px solid #14532d;
  padding:10px 12px; border-radius:10px;
}

/* Mobile tweaks */
@media (max-width: 420px) {
  .admin-screen { padding: 12px; gap: 12px; }
  .card { padding: 12px; border-radius: 12px; }
  .title { font-size: 18px; }
  .pill { padding: 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/admpelada.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB,SAAS,cAAc;EAC1C,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA,kBAAkB,aAAa,EAAE,QAAQ,EAAE;;AAE3C,UAAU;AACV;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA,aAAa,wBAAwB,EAAE;AACvC,gBAAgB,YAAY,EAAE,mBAAmB,EAAE;;AAEnD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;AACA,SAAS,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC1D,cAAc,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAClE,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAE9D;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;AACA,eAAe,qBAAqB,EAAE;AACtC,aAAa,eAAe,EAAE;;AAE9B;EACE,mBAAmB;EACnB,aAAa,EAAE,yBAAyB,EAAE,QAAQ,EAAE,eAAe;AACrE;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB,aAAa,aAAa,EAAE,QAAQ,EAAE;AACtC,cAAc,eAAe,EAAE,cAAc,EAAE;AAC/C,cAAc,gBAAgB,EAAE;;AAEhC,sBAAsB;AACtB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA,mBAAmB,cAAc,EAAE,qBAAqB,EAAE;AAC1D,mBAAmB,cAAc,EAAE,qBAAqB,EAAE;AAC1D,mBAAmB,cAAc,EAAE,qBAAqB,EAAE;AAC1D,mBAAmB,cAAc,EAAE,qBAAqB,EAAE;;AAE1D,kDAAkD;AAClD;EACE,aAAa;EACb,QAAQ;EACR,2DAA2D,EAAE,8BAA8B;EAC3F,mBAAmB;AACrB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB,UAAU,wBAAwB;EAClD,sBAAsB;AACxB;AACA,eAAe,eAAe,EAAE,cAAc,EAAE;AAChD,eAAe,eAAe,EAAE;AAChC,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,kDAAkD,EAAE;;AAEpE,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,kBAAkB;AACpB;AACA,kBAAkB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACtE;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,wDAAwD;AAC1D;;AAEA,YAAY;AACZ,SAAS,cAAc,EAAE,eAAe,EAAE;AAC1C;EACE,kBAAkB,EAAE,aAAa,EAAE,wBAAwB;EAC3D,iBAAiB,EAAE,kBAAkB;AACvC;AACA;EACE,kBAAkB,EAAE,aAAa,EAAE,wBAAwB;EAC3D,iBAAiB,EAAE,kBAAkB;AACvC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB,aAAa,EAAE,SAAS,EAAE;EAC1C,QAAQ,aAAa,EAAE,mBAAmB,EAAE;EAC5C,SAAS,eAAe,EAAE;EAC1B,QAAQ,aAAa,EAAE;AACzB","sourcesContent":["/* components/admpelada.css */\n\n/* Container & Header */\n.admin-screen {\n  display: grid;\n  gap: 16px;\n  padding: 16px;\n  background: #0b1220;        /* dark base */\n  min-height: 100vh;\n  color: #e5e7eb;\n}\n.admin-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.title {\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: 0.2px;\n}\n.header-actions { display: flex; gap: 8px; }\n\n/* Cards */\n.card {\n  background: #0e172a;\n  border: 1px solid #1f2a44;\n  border-radius: 14px;\n  padding: 14px;\n  box-shadow: 0 6px 16px rgba(0,0,0,0.35);\n}\n.card__head {\n  display: flex; align-items: center; justify-content: space-between;\n  margin-bottom: 10px;\n}\n.card__title {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n/* Buttons */\n.btn {\n  background: #1f2a44;\n  border: 1px solid #283759;\n  color: #e5e7eb;\n  padding: 10px 12px;\n  border-radius: 10px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.btn:hover { filter: brightness(1.08); }\n.btn:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.btn--primary {\n  background: #10b981;\n  border-color: #0f9d75;\n  color: #06251f;\n}\n.btn--ghost {\n  background: transparent;\n  border-color: #283759;\n}\n\n/* Form / Read grids (responsivas) */\n.form-grid, .read-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n}\n.field { display: flex; flex-direction: column; gap: 6px; }\n.field--row { flex-direction: row; align-items: center; gap: 8px; }\n.label-inline { display: flex; align-items: center; gap: 8px; }\n\n.input {\n  background: #0b1220;\n  color: #e5e7eb;\n  border: 1px solid #1f2a44;\n  padding: 10px 12px;\n  border-radius: 10px;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n}\n.input:focus { border-color: #375399; }\n.input--xs { max-width: 96px; }\n\n.form-actions {\n  grid-column: 1 / -1;\n  display: flex; justify-content: flex-end; gap: 8px; margin-top: 6px;\n}\n.divider {\n  grid-column: 1 / -1;\n  height: 1px;\n  background: #1f2a44;\n  margin: 2px 0 8px 0;\n}\n\n/* Read-only items */\n.read-item { display: grid; gap: 4px; }\n.read-label { font-size: 12px; color: #9ca3af; }\n.read-value { font-weight: 600; }\n\n/* Badges traduzidas */\n.badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  border: 1px solid #283759;\n  background: #0b1220;\n}\n.badge--open     { color: #10b981; border-color: #0f9d75; }\n.badge--closed   { color: #f59e0b; border-color: #9a6b09; }\n.badge--canceled { color: #f97373; border-color: #7f1d1d; }\n.badge--finished { color: #93c5fd; border-color: #1d4ed8; }\n\n/* Pills (chips) — responsivas, sem sobreposição */\n.pill-row {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); /* quebre conforme a largura */\n  margin-bottom: 10px;\n}\n.pill {\n  display: flex; align-items: center; justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid #283759;\n  background: #0b1220;\n  font-weight: 700;\n  min-height: 44px;         /* área toque-friendly */\n  box-sizing: border-box;\n}\n.pill__label { font-size: 13px; color: #9ca3af; }\n.pill__value { font-size: 14px; }\n.pill--green  { border-color: #0f9d75; }\n.pill--amber  { border-color: #9a6b09; }\n.pill--red    { border-color: #7f1d1d; }\n.pill--over   { box-shadow: inset 0 0 0 999px rgba(127,29,29,0.08); }\n\n/* Progress — responsivo */\n.progress-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  margin-bottom: 4px;\n}\n.progress-title { font-size: 12px; color: #9ca3af; margin: 2px 0 6px; }\n.progress {\n  width: 100%;\n  height: 10px;\n  background: #0b1220;\n  border: 1px solid #1f2a44;\n  border-radius: 999px;\n  overflow: hidden;\n}\n.progress__bar {\n  height: 100%;\n  background: linear-gradient(90deg, #375399, #10b981 66%);\n}\n\n/* Helpers */\n.muted { color: #9ca3af; font-size: 12px; }\n.error-message {\n  background:#2a0f11; color:#fecaca; border:1px solid #7f1d1d;\n  padding:10px 12px; border-radius:10px;\n}\n.success-message {\n  background:#0f2a17; color:#bbf7d0; border:1px solid #14532d;\n  padding:10px 12px; border-radius:10px;\n}\n\n/* Mobile tweaks */\n@media (max-width: 420px) {\n  .admin-screen { padding: 12px; gap: 12px; }\n  .card { padding: 12px; border-radius: 12px; }\n  .title { font-size: 18px; }\n  .pill { padding: 10px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
